'use client'

import { useSession } from 'next-auth/react'

import { CookieNamesEnum } from '@/enums/CookieNamesEnum'
import { resolveSelectedOrgUnitId } from '@/helpers/getSelectedOrgUnitId'
import { useCookie } from '@/hooks/useCookie'

// Also sent as the X-OrgUnit header by src/lib/clients/refactored/bffClient.ts.
export const useSelectedOrgUnitId = (): string => {
  const [selectedOrgUnitCookie] = useCookie(CookieNamesEnum.SelectedOrgUnit, '')
  const { data: session } = useSession()

  return resolveSelectedOrgUnitId(session, selectedOrgUnitCookie) ?? ''
}
